import { render, staticRenderFns } from "./AMLiquidacionDetalle.vue?vue&type=template&id=65af43f0"
import script from "./AMLiquidacionDetalle.vue?vue&type=script&lang=js"
export * from "./AMLiquidacionDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports